import { Flow_0_0_2 } from '@flexus/core';

export const BET_161: Flow_0_0_2 = {
	id: '161',
	name: 'paused_no_excess',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for customer to pay excess'
		}
	},
	startNode: '',
	nodes: {}
};
